import {
  // IconBarrierBlock,
  // IconBrowserCheck,
  // IconBug,
  // IconChecklist,
  // IconError404,
  // IconHelp,
  // IconLayoutDashboard,
  // IconLock,
  // IconLockAccess,
  // IconMessages,
  // IconNotification,
  // IconPackages,
  // IconPalette,
  // IconServerOff,
  // IconSettings,
  // IconTool,
  // IconUserCog,
  // IconUserOff,
  IconUsers,
  IconId,
  IconBarrierBlock,
  IconBrowserCheck,
  IconBug,
  IconChecklist,
  IconError404,
  IconHelp,
  IconLayoutDashboard,
  IconLock,
  IconLockAccess,
  IconMessages,
  IconNotification,
  IconPackages,
  IconPalette,
  IconServerOff,
  IconSettings,
  IconTool,
  IconUserCog,
  IconUserOff,
  IconBuilding,
  IconFolder,
  IconCalendarOff,
  IconPackage,
  IconShoppingCart,
  IconCalendar,
  IconCreditCardPay,
  IconList,
  IconQuestionMark,
  IconBulb,
  IconTag,
} from '@tabler/icons-react'
import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react'
import { type SidebarData } from '../types'
import { useAuth } from '@/context/auth-context'
import { t, tWithNamespace } from '@/lib/i18n'
import { Permissions } from '@/constants/roles-permissions'

// Create function to get sidebar data with current user
export function getSidebarData(): SidebarData {
  const defaultAvatar = '/avatars/shadcn.jpg'

  // Create namespaced translation helpers
  const st = tWithNamespace('sidebar')
  const teams = tWithNamespace('sidebar.teams')
  const groups = tWithNamespace('sidebar.groups')
  const items = tWithNamespace('sidebar.items')

  return {
    // Use fallback values for initial render or when not authenticated
    user: {
      name: 'default',
      email: 'default@gmail.com',
      avatar: defaultAvatar,
    },
    teams: [
      {
        name: teams('employeeProfiles'),
        logo: Command,
        plan: '',
      },
      // {
      //   name: 'Trang thông tin',
      //   logo: GalleryVerticalEnd,
      //   plan: '',
      // }
    ],
    navGroups: [
      {
        title: groups('general'),
        items: [
          {
            title: 'Cổng thông tin cá nhân',
            url: '/employee-portal',
            icon: IconUserCog,
            permission: Permissions.EmployeePortal,
          },
          {
            title: items('employeeProfiles'),
            url: '/employees',
            icon: IconId,
            permission: Permissions.EmployeeView,
          },
          {
            title: 'Tra cứu hồ sơ bị cấm',
            url: '/banned-employees',
            icon: IconBarrierBlock,
            permission: Permissions.EmployeeBannedView,
          },
          {
            title: items('profileDashboard'),
            url: '/profile-dashboard',
            icon: IconLayoutDashboard,
            permission: Permissions.EmployeeView,
          },
          {
            title: "Thu chi",
            icon: IconCreditCardPay,
            // Example: Allow access if user has ANY of these permissions
            permission: [Permissions.AccountingTransactionView,
            Permissions.AccountingTransactionCreate,
            Permissions.AccountingTransactionEdit,
            Permissions.AccountingTransactionDelete,
            Permissions.AccountingTransactionExport,
            Permissions.AccountingTransactionVerify,
            Permissions.AccountingTransactionApprove],
            items: [
              {
                title: 'Thống kê',
                url: '/accounting-dashboard',
                permission: Permissions.AccountingTransactionView,
              },
              {
                title: 'Danh sách',
                url: '/accounting-transaction',
                permission: [Permissions.AccountingTransactionView,
                Permissions.AccountingTransactionEdit,
                Permissions.AccountingTransactionCreate,
                Permissions.AccountingTransactionDelete,
                Permissions.AccountingTransactionExport,
                Permissions.AccountingTransactionVerify,
                Permissions.AccountingTransactionApprove
                ],
              },
              // {
              //   title: 'Cài đặt kế hoạch',
              //   url: '/business-plan-settings',
              //   permission: Permissions.AccountingTransactionView,
              // },
              // {
              //   title: 'Báo cáo kinh doanh',
              //   url: '/business-report',
              //   permission: Permissions.AccountingTransactionView,
              // }
            ],
          },
          {
            title: 'Lương công nhân',
            icon: IconCreditCardPay,
            permission: Permissions.EmployeeViewBalance,
            items: [
              {
                title: 'Thống kê',
                url: '/payslip-dashboard',
                permission: Permissions.EmployeeViewBalance,
              },
              {
                title: 'Phiếu lương',
                url: '/payslip-management',
                permission: Permissions.EmployeeViewBalance,
              },
              {
                title: 'Danh sách GD',
                url: '/employee-wallet',
                permission: Permissions.EmployeeViewBalance,
              },
              {
                title: 'Phiếu hoa hồng',
                url: '/commission-payslips',
                permission: Permissions.EmployeeViewBalance,
              },
            ],
          },
          // {
          //   title: 'Phân tích nhân sự',
          //   url: '/workforce-insights',
          //   icon: IconLayoutDashboard,
          //   permission: Permissions.EmployeeProfileView,
          // },
          {
            title: items('timeKeeping'),
            icon: IconCalendar,
            permission: Permissions.LeaveView,
            items: [
              // {
              //   title: 'Thống kê',
              //   url: '/workforce-analytics',
              //   permission: Permissions.LeaveView,
              // },
              {
                title: 'Danh sách chấm công',
                url: '/timekeeping',
                permission: Permissions.LeaveView,
              },
              {
                title: 'Thống kê ngày nghỉ',
                url: '/leave-tracking',
                permission: Permissions.LeaveView,
              },
              {
                title: 'Thống kê chuyên cần',
                url: '/diligent-employees',
                permission: Permissions.LeaveView,
              },
              {
                title: 'Quản lý nghỉ lễ',
                url: '/holiday-setting',
                permission: Permissions.HolidayView,
              },
            ],
          },
          {
            title: 'Tiêu dùng',
            icon: IconShoppingCart,
            permission: Permissions.EmployeeAssetView,
            items: [
              {
                title: 'Thống kê',
                url: '/employee-assets-dashboard',
                permission: Permissions.EmployeeAssetView,
              },
              {
                title: 'Danh sách',
                url: '/employee-assets',
                permission: Permissions.EmployeeAssetView,
              },
            ],
          },
          {
            title: 'Quà tặng',
            url: '/employee-gifts',
            icon: IconPackage,
            permission: Permissions.EmployeeGiftView,
          },
          {
            title: 'Hợp đồng',
            icon: IconId,
            permission: Permissions.LaborContractView,
            items: [
              {
                title: 'Danh sách',
                url: '/labor-contracts',
                permission: Permissions.LaborContractView,
              },
              {
                title: 'Thống kê BHXH',
                url: '/insurance-dashboard',
                permission: Permissions.LaborContractView,
              },
              {
                title: 'Thống kê hợp đồng',
                url: '/labor-contract-dashboard',
                permission: Permissions.LaborContractView,
              },
              // {
              //   title: 'Đề xuất',
              //   url: '/labor-contract-generation',
              //   permission: Permissions.LaborContractView,
              // },
            ],
          },
          {
            title: 'Quản lý ký túc xá',
            icon: IconBuilding,
            permission: Permissions.DormitoryView,
            items: [
              {
                title: 'Sơ đồ',
                url: '/dormitory-hierachy',
                permission: Permissions.DormitoryView,
              },
              {
                title: 'Vị trí',
                url: '/dormitory-management',
                permission: Permissions.DormitoryView,
              }

            ],
          },
          // {
          //   title: items('dashboard'),
          //   url: '/',
          //   icon: IconLayoutDashboard,
          // },
          // {
          //   title: items('tasks'),
          //   url: '/tasks',
          //   icon: IconChecklist,
          // },
          // {
          //   title: items('apps'),
          //   url: '/apps',
          //   icon: IconPackages,
          // },
          // {
          //   title: items('chats'),
          //   url: '/chats',
          //   badge: '3',
          //   icon: IconMessages,
          // },
          {
            title: items('fileStorage'),
            url: '/file-storage',
            icon: IconFolder,
            permission: Permissions.FileStorageView,
          },
          {
            title: "Yêu cầu",
            url: '/request-ticket',
            icon: IconQuestionMark,
            permission: Permissions.FileStorageView,
          },
          {
            title: items('users'),
            url: '/users',
            icon: IconUsers,
            permission: Permissions.UserView,
          },

          {
            title: items('settings'),
            icon: IconLockAccess,
            items: [
              {
                title: items('roles'),
                url: '/roles',
                icon: IconLockAccess,
                permission: Permissions.RoleView,
              },
              {
                title: items('companies'),
                url: '/companies',
                icon: IconBuilding,
                permission: Permissions.CompanyView,
              },
              {
                title: items('employeeGroups'),
                url: '/employee-groups',
                icon: IconUsers,
                permission: Permissions.EmployeeGroupView,
              },
              {
                title: "Mặt hàng tiêu dùng",
                url: '/assets',
                icon: IconPackage,
                permission: Permissions.AssetView,
              },
              {
                title: 'Danh mục thu chi',
                url: '/transaction-category',
                icon: IconList,
                permission: Permissions.TransactionCategoryView,
              },
              {
                title: 'Kỹ năng',
                url: '/skills',
                icon: IconBulb,
                permission: Permissions.SkillView,
              },
              {
                title: 'Thẻ',
                url: '/custom-tag',
                icon: IconTag,
                permission: Permissions.CustomTagView,
              },
              {
                title: 'Nhật ký hoạt động',
                url: '/user-activity-logs',
                icon: IconChecklist,
                permission: Permissions.UserActivityView,
              },
              {
                title: items('userSessions'),
                url: '/user-sessions',
                icon: IconBrowserCheck,
                permission: Permissions.UserActivityView,
              },
            ],
          },
        ],
      },
      // {
      //   title: groups('pages'),
      //   items: [
      //     {
      //       title: items('auth'),
      //       icon: IconLockAccess,
      //       items: [
      //         {
      //           title: items('signIn'),
      //           url: '/sign-in',
      //         },
      //         {
      //           title: items('signIn2Col'),
      //           url: '/sign-in-2',
      //         },
      //         {
      //           title: items('signUp'),
      //           url: '/sign-up',
      //         },
      //         {
      //           title: items('forgotPassword'),
      //           url: '/forgot-password',
      //         },
      //         {
      //           title: items('otp'),
      //           url: '/otp',
      //         },
      //       ],
      //     },
      //     {
      //       title: items('errors'),
      //       icon: IconBug,
      //       items: [
      //         {
      //           title: items('unauthorized'),
      //           url: '/401',
      //           icon: IconLock,
      //         },
      //         {
      //           title: items('forbidden'),
      //           url: '/403',
      //           icon: IconUserOff,
      //         },
      //         {
      //           title: items('notFound'),
      //           url: '/404',
      //           icon: IconError404,
      //         },
      //         {
      //           title: items('internalServerError'),
      //           url: '/500',
      //           icon: IconServerOff,
      //         },
      //         {
      //           title: items('maintenanceError'),
      //           url: '/503',
      //           icon: IconBarrierBlock,
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        title: groups('other'),
        items: [
          // {
          //   title: items('settings'),
          //   icon: IconSettings,
          //   items: [
          //     {
          //       title: items('profile'),
          //       url: '/settings/profile',
          //       icon: IconUserCog,
          //       permission: Permissions.PersonalView,
          //     },
          //     // {
          //     //   title: items('account'),
          //     //   url: '/settings/account',
          //     //   icon: IconTool,
          //     // },
          //     // {
          //     //   title: items('appearance'),
          //     //   url: '/settings/appearance',
          //     //   icon: IconPalette,
          //     // },
          //     // {
          //     //   title: items('notifications'),
          //     //   url: '/settings/notifications',
          //     //   icon: IconNotification,
          //     // },
          //     // {
          //     //   title: items('display'),
          //     //   url: '/settings/display',
          //     //   icon: IconBrowserCheck,
          //     // },
          //   ],
          // },
          {
            title: items('profile'),
            url: '/settings/profile',
            icon: IconUserCog,
            // permission: Permissions.PersonalView,
          },
          // {
          //   title: items('helpCenter'),
          //   url: '/help-center',
          //   icon: IconHelp,
          // },
        ],
      },
    ],
  }
}

// Create hook to get sidebar data with authenticated user
export function useSidebarData(): SidebarData {
  const { user, isAuthenticated, hasPermission } = useAuth()
  const sidebarData = getSidebarData()

  // Update user info from auth context if authenticated
  if (isAuthenticated && user) {
    sidebarData.user = {
      name: user.fullName || user.username,
      email: user.email,
      avatar: '/avatars/shadcnjpg', // You may want to update this to use user's avatar if available
    }

    // Filter navigation items based on permissions
    sidebarData.navGroups = sidebarData.navGroups
      .map(group => ({
        ...group,
        items: filterSidebarItems(group.items, hasPermission)
      }))
      .filter(group => group.items.length > 0);
  }

  return sidebarData
}

// For backward compatibility, also export a default instance
export const sidebarData = getSidebarData()

// Helper function to check if user has any of the required permissions
function hasAnyPermission(permission: string | string[] | undefined, hasPermission: (permission: string) => boolean): boolean {
  if (!permission) return true; // No permission required

  if (Array.isArray(permission)) {
    // OR logic: user needs at least one of the permissions
    return permission.some(p => hasPermission(p));
  }

  // Single permission check
  return hasPermission(permission);
}

// Create function to recursively filter sidebar items by permission
function filterSidebarItems(items: any[], hasPermission: (permission: any) => boolean): any[] {
  return items
    .map(item => {
      if (item.items) {
        const filteredSubItems = filterSidebarItems(item.items, hasPermission)
        if (filteredSubItems.length > 0) {
          return { ...item, items: filteredSubItems }
        }
        // Nếu không còn subitems, chỉ giữ lại nếu item cha có quyền
        return hasAnyPermission(item.permission, hasPermission) ? { ...item, items: [] } : null
      }
      return hasAnyPermission(item.permission, hasPermission) ? item : null
    })
    .filter(Boolean)
}
